// extracted by mini-css-extract-plugin
export default {"form":"ForgotPassword_form__suotJ"};